'use strict';

angular.module('app.advertiserPerferredDetail', [])

.controller('advertiserPerferredDetailCtrl', function ($scope, $rootScope, $http, localStorageService, $modal) {
       
    $scope.urlList = [];
    $scope.tempList = [];

    $scope.preferedBlogs.forEach(function(val){
        $scope.urlList.push(val.blog)
    })
        
    $scope.save = function(){
        var req = {
            url: $rootScope.apiUrl + 'preferredblog',
            method: 'POST',
            data: {
                blogs: $scope.blogsToBeAdded,
                remove: $scope.blogsToBeDeleted,
                advertiserID: $rootScope.sideMenuSelections.advertiserId || null
            }
        }

        $http(req).success(function(response){        

            $rootScope.$broadcast('reload_advertiserPreferredList', { advertiserId: $rootScope.sideMenuSelections.advertiserId});

            $scope.currentUser.company.preferedBlogs = response.data;
            $rootScope.currentUser.company.preferedBlogs = response.data;
            localStorageService.set('currentUser', $scope.currentUser);

            //close modal
            $scope.modalInstance.close(function(){
                $log.info('Close Modal now');
            })
        });            
    };

    $scope.blogsToBeAdded = [];
    $scope.blogsToBeDeleted = [];

    $scope.delete = function(index){
        $scope.blogsToBeDeleted.push($scope.urlList[index].id);
        $scope.urlList.splice(index, 1)
    };
    
    $scope.availableTags = function(val) {
        $scope.errorMessage = "";
        return $http.get($rootScope.apiUrl + 'domain', {
            loader: true,
            params: {
                find: val
            }
        }).then(function(response) {  
            return angular.forEach(response.data, function(item) {
                return {id: item.id, domain: item.domain};
            }); 
        }, function(response) {
            if(response.data != null) {
                if(response.data.message != null) {
                    var errorModalInstance = $modal.open({
                        scope: $scope,
                        templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                        windowClass: 'modal-dialog-mention-error'
                    });
                    $scope.errorModalInstance = errorModalInstance;
                    $scope.errorMessage = response.data.message;
                }
            }
        });
    };

    $scope.afterSelectTag = function(item){
        var currentBlogIds = $scope.preferedBlogs.map(function(row){
            return row.blog.id
        })

        if (currentBlogIds.indexOf(item.id) ===-1 && $scope.blogsToBeAdded.indexOf(item.id) === -1) {
            $scope.blogsToBeAdded.push(item.id);
            $scope.urlList.push(item);
        }else{
            $(".modal-dialog .modal-content").effect("shake")
        }

        $scope.selectedTag = ""; 
    };
    
})